import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ClickOutsideModule } from 'ng4-click-outside';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AppComponent } from './app.component';
import { NAV_DROPDOWN_DIRECTIVES } from './shared/nav-dropdown.directive';

import { APP_INITIALIZER } from '@angular/core';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { AsideToggleDirective } from './shared/aside.directive';
import { BreadcrumbsComponent } from './shared/breadcrumb.component';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';

// Routing Module
import { AppRoutingModule } from './app.routing';
import { FranceConnectModule } from './components/france-connect/france-connect.module';

import { LegacyLoginModule } from './components/legacy-login/legacy-login.module';

// Layouts
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { CookieService } from 'ngx-cookie-service';
import { FullLayoutComponent } from './layouts/full-layout.component';
import { AppConfigService } from './services/app-config.service';

// home views
import { AppHomeTextComponent } from './components/app-home-text/app-home-text.component';

// Form Dia views
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatInputModule } from '@angular/material';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { AppFormAComponent } from './components/app-form-a/app-form-a.component';
import { AppFormAcceptComponent } from './components/app-form-accept/app-form-accept.component';
import { AppFormBComponent } from './components/app-form-b/app-form-b.component';
import { AppFormCComponent } from './components/app-form-c/app-form-c.component';
import { AppFormDComponent } from './components/app-form-d/app-form-d.component';
import { AppFormEComponent } from './components/app-form-e/app-form-e.component';
import { AppFormFComponent } from './components/app-form-f/app-form-f.component';
import { AppFormGComponent } from './components/app-form-g/app-form-g.component';
import { AppFormHComponent } from './components/app-form-h/app-form-h.component';
import { AppFormIComponent } from './components/app-form-i/app-form-i.component';
import { AppFormJComponent } from './components/app-form-j/app-form-j.component';
import { AppFormValidationComponent } from './components/app-form-validation/app-form-validation.component';
import { AppUploadFilesModule } from './components/app-upload-files/app-upload-files.module';
import { ModalConfirmDeleteComponent } from './components/modal-confirm-delete/modal-confirm-delete.component';
import { ModalExpiredDraftComponent } from './components/modal-expired-draft/modal-expired-draft.component';
import { FormVerificationService } from './shared/services/form-verification.service';

// Pipes
import { LocalStorageService } from './shared';
import { NumericInputDirective } from './shared/directives/numeric-input.directive';
import { AuthGuard } from './shared/guards/auth.guard';
import { AuthRefreshInterceptor } from './shared/interceptors/auth-refresh.interceptor';
import { CredentialsInterceptor } from './shared/interceptors/credentials.interceptor';
import { SafeHtmlPipe } from './shared/pipes/safehtml.pipe';
import { AuthTokenService } from './shared/services/auth-token.service';

export function initializeApp(appConfig: AppConfigService) {
  return () => appConfig.load();
}

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    HttpModule,
    HttpClientModule,
    FranceConnectModule,
    LegacyLoginModule,
    AppUploadFilesModule,
    BsDropdownModule,
    CommonModule,
    FormsModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    ToastModule.forRoot(),
    NgbModule.forRoot(),
    ClickOutsideModule
  ],
  declarations: [
    AppComponent,
    FullLayoutComponent,
    NAV_DROPDOWN_DIRECTIVES,
    BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
    AppHomeTextComponent,
    AppFormAComponent,
    AppFormBComponent,
    AppFormCComponent,
    AppFormDComponent,
    AppFormEComponent,
    AppFormFComponent,
    AppFormGComponent,
    AppFormHComponent,
    AppFormIComponent,
    AppFormJComponent,
    AppFormAcceptComponent,
    AppFormValidationComponent,
    ModalConfirmDeleteComponent,
    ModalExpiredDraftComponent,
    SafeHtmlPipe,
    NumericInputDirective
  ],
  exports: [
    AppFormAComponent,
    AppFormBComponent,
    AppFormCComponent,
    AppFormDComponent,
    AppFormEComponent,
    AppFormFComponent,
    AppFormGComponent,
    AppFormHComponent,
    AppFormIComponent,
    AppFormJComponent,
    AppFormAcceptComponent,
    AppFormValidationComponent
  ],
  providers: [
    {
      provide: LocationStrategy,
      // Préféré à HashLocationStrategy (pour pouvoir gérer les retours de FranceConnect)
      useClass: PathLocationStrategy
    },
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService], multi: true
    },
    CookieService,
    FormVerificationService,
    LocalStorageService,
    AuthTokenService,
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: CredentialsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthRefreshInterceptor, multi: true }
  ],
  bootstrap: [ AppComponent ],
  entryComponents: [
    AppHomeTextComponent,
    AppFormAComponent,
    AppFormBComponent,
    AppFormCComponent,
    AppFormDComponent,
    AppFormEComponent,
    AppFormFComponent,
    AppFormGComponent,
    AppFormHComponent,
    AppFormIComponent,
    AppFormJComponent,
    AppFormAcceptComponent,
    AppFormValidationComponent,
    ModalConfirmDeleteComponent,
    ModalExpiredDraftComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts